module.exports = "/fonts/TT-Norms-Pro-Medium.ttf";